export const DROPDOWN_OPEN_EVENT = "workspace:dropdown-open";

/**
 * Close independent dropdowns before a pane or modal takes focus. Dropdowns
 * intentionally nested in another overlay opt out with disableGlobalCloseEvent.
 */
export function closeIndependentDropdowns() {
  window.dispatchEvent(new CustomEvent(DROPDOWN_OPEN_EVENT));
}
